/*
 * @Descripttion: 
 * @version: 
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-08-19 18:58:29
 * @LastEditors: linxi
 * @LastEditTime: 2025-09-09 18:48:30
 */
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Col,
  Form,
  Input,
  notification,
  Popover,
  Row,
  Select,
  Space,
  Table,
} from 'antd'
import React, {
  ReactElement,
  useContext,
  useEffect,
  useState,
  useRef,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectTenantName } from '../../../app/applicationSlice'
import { RootDispatch } from '../../../app/store'
import {
  DateRangeType,
  DateSelect,
  TJFXTime,
} from '../../../compnents/form/DateSelect'
import { EditableColumnType, EditableList } from '../../../compnents/list/EditableList'
import {
  BillingCategories,
  BillingCategory,
  BillingCategoryName,
} from '../../../models/billingCategory'
import { User } from '../../../models/user'
import { ThemeContext } from '../../../theme/ThemeContext'
import styles from './DoctorAudit.module.css'
import {
  getDoctorAuditEntries,
  getDoctorAuditExoprt,
  getDoctorList,
  selectGetDoctorAuditEntriesParam,
  setGetDoctorAuditEntriesParam,
} from './doctorAuditSlice'

import { PrintFrame, PrintFrameRef } from '../../print/PrintFrame'

import { DoctorSaleEntry, DoctorSalesResult } from '../../../models/doctorSales'
import { QuestionCircleTwoTone } from '@ant-design/icons'
const TreatmentKeys = [
  'name',
  'accountUnit',
  'treatmentDoctorName',
  'totalCount',
  'totalRetail',
  'estimateRealPayAmount',
  'totalCost',
  'profitRate',
  'totalDiff',
]

export const DoctorAudit = (): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext)

  const [form] = Form.useForm()

  const params = useSelector(selectGetDoctorAuditEntriesParam)

  const name = useSelector(selectTenantName)

  const [doctors, setDoctors] = useState<User[]>([])

  const [all, setAll] = useState<any>()

  const [entries, setEntries] = useState<Record<string, unknown>[]>([])

  const [page, setPage] = useState<any>({
    total: 1,
    items: [],
  })

  const printRef = useRef<PrintFrameRef>(null)

  const [result, setResult] = useState({
    headers: [],
    entries: [],
  } as DoctorSalesResult)

  const [pageLoading, setPageLoading] = useState(false) //表格 loading

  const [exportLoading, setExportLoading] = useState(false) //导出 loading

  useEffect(() => {
    try {
      setPageLoading(true)
      dispatch(getDoctorAuditEntries(params))
        .then(unwrapResult)
        .then((data: any) => {
          setPage({
            items: data?.doctorAccountingSummaries,
            total: data?.total < 0 ? 0 : data?.total || 0,
          })
          // setEntries(data?.doctorAccountingSummaries)
          setAll(data)
        })
        .finally(() => setPageLoading(false))
    } catch {
      // do nothing.
    }
  }, [params])

  useEffect(() => {
    try {
      dispatch(getDoctorList())
        .then(unwrapResult)
        .then((doctors) => setDoctors(doctors))
    } catch {
      // do nothing.
    }
    form.setFieldsValue({ ...params })
  }, [])

  const outClued = () => {
    setExportLoading(true)
    dispatch(getDoctorAuditExoprt(params))
      .then(unwrapResult)
      .then((res: any) => {
        const content = res
        const blob = new Blob([content])
        const fileName = '医生核算明细.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          return (navigator as any).msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        notification.success({
          message: '导出成功',
          duration: 3,
        })
      })
      .catch((res: any) => {
        return
      })
      .finally(() => setExportLoading(false))
  }

  const Tips = (title: string) => (
    <>
      {title}
      <Popover
        placement='top'
        content='实收金额=(药品售价÷总金额)×应收金额，四舍五入后保留2位小数，和实际实收总金额会有些许误差'
      >
        <QuestionCircleTwoTone style={{ marginLeft: '5px' }} />
      </Popover>
    </>
  )

  const columns: EditableColumnType<Record<string, any>>[] = [
    {
      title: `${params.drugType === 1 ? '诊疗' : '药品'}名称`,
      dataIndex: 'name',
      align: 'center',
      width: '12rem',
      ellipsis: true,
    },
    {
      title: '规格',
      dataIndex: 'packSpec',
      align: 'center',
      width: '12rem',
      ellipsis: true,
    },
    {
      title: '供应商',
      dataIndex: 'gysName',
      align: 'center',
      width: '12rem',
      ellipsis: true,
    },
    {
      title: '厂家',
      dataIndex: 'tenantSupplierName',
      align: 'center',
      width: '12rem',
      ellipsis: true,
    },
    {
      title: '批次',
      dataIndex: 'batchNo',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, r) => (r.batchNo ? r.batchNo : '-'),
    },
    {
      title: '开票项目',
      key: 'billingCategory',
      dataIndex: 'billingCategory',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, d) =>
        BillingCategoryName(d.billingCategory as BillingCategory),
    },
    {
      title: '单位',
      dataIndex: 'accountUnit',
      align: 'center',
      width: '4rem',
      ellipsis: true,
    },
    {
      title: '开单医生',
      dataIndex: 'treatmentDoctorName',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, e) => {
        return {
          props: {
            style: {
              whiteSpace: 'nowrap',
            },
          },
          children: e.treatmentDoctorName,
        }
      },
    },
    {
      title: '数量',
      dataIndex: 'totalCount',
      align: 'right',
      width: '4rem',
      ellipsis: true,
    },
    {
      title: '零售金额',
      key: 'totalRetail',
      dataIndex: 'totalRetail',
      align: 'right',
      width: '6rem',
      ellipsis: true,
      render: (_, r) => r.totalRetail?.toFixed(2),
    },
    {
      title: Tips('实收金额'),
      key: 'estimateRealPayAmount',
      dataIndex: 'estimateRealPayAmount',
      align: 'right',
      width: '7rem',
      ellipsis: true,
      render: (_, r) => r.estimateRealPayAmount?.toFixed(2),
    },
    {
      title: '进货金额',
      dataIndex: 'totalCost',
      align: 'right',
      width: '6rem',
      ellipsis: true,
      render: (_, r) => r.totalCost?.toFixed(2),
    },
    {
      title: '利润率',
      dataIndex: 'profitRate',
      align: 'right',
      width: '5rem',
      ellipsis: true,
      render: (_, r) => r.profitRate?.toFixed(2),
    },
    {
      title: '利润',
      dataIndex: 'totalDiff',
      align: 'right',
      width: '5rem',
      ellipsis: true,
      render: (_, r) => r.totalDiff?.toFixed(2),
    },
  ]
  const footingColumns: EditableColumnType<Record<string, any>>[] = [
    {
      title: `${params.drugType === 1 ? '诊疗' : '药品'}名称`,
      dataIndex: 'name',
      align: 'center',
    },
    {
      title: '规格',
      dataIndex: 'packSpec',
      align: 'center',
    },
    {
      title: '厂家',
      dataIndex: 'tenantSupplierName',
      align: 'center',
    },
    {
      title: '批次',
      dataIndex: 'batchNo',
      align: 'center',
      render: (_, r) => (r.batchNo ? r.batchNo : '-'),
    },
    {
      title: '开票项目',
      key: 'billingCategory',
      dataIndex: 'billingCategory',
      render: (_, d) =>
        BillingCategoryName(d.billingCategory as BillingCategory),
    },
    {
      title: '单位',
      dataIndex: 'accountUnit',
      align: 'center',
    },
    {
      title: '开单医生',
      dataIndex: 'treatmentDoctorName',
      align: 'center',
      render: (_, e) => {
        return {
          props: {
            style: {
              whiteSpace: 'nowrap',
            },
          },
          children: e.treatmentDoctorName,
        }
      },
    },
    {
      title: '数量',
      dataIndex: 'totalCount',
      align: 'right',
    },
    {
      title: '零售金额',
      key: 'totalRetail',
      align: 'right',
      render: (_, r) => r.totalRetail?.toFixed(2),
    },
    {
      title: Tips('实收金额'),
      key: 'estimateRealPayAmount',
      dataIndex: 'estimateRealPayAmount',
      align: 'right',
      width: '7rem',
      ellipsis: true,
      render: (_, r) => r.estimateRealPayAmount?.toFixed(2),
    },
    {
      title: '进货金额',
      dataIndex: 'totalCost',
      align: 'right',
      render: (_, r) => r.totalCost?.toFixed(2),
    },
    {
      title: '利润率',
      dataIndex: 'profitRate',
      align: 'right',
      render: (_, r) => r.profitRate?.toFixed(2),
    },
    {
      title: '利润',
      dataIndex: 'totalDiff',
      align: 'right',
      render: (_, r) => r.totalDiff?.toFixed(2),
    },
  ]
  const table = (type = false) => (
    <>
      <EditableList
        className={type ? styles.tables : styles.table}
        loading={pageLoading}
        // rowClassName={(e) =>
        //   e.treatmentDoctorName === "合计" ? styles.total : ""
        // }
        bordered={!type}
        page={{
          items: page?.items,
          current: params?.current || 1,
          size: params?.size || 10,
          total: page?.total,
        }}
        dataSource={entries}
        rowKey={(_, i) => `${i}}`}
        style={{ flex: 1, overflow: 'auto' }}
        columns={columns.filter((c) =>
          params.drugType === 1
            ? TreatmentKeys.includes(c.dataIndex as string)
            : true
        )}
        onChangePage={(current, size) => {
          dispatch(
            setGetDoctorAuditEntriesParam({
              ...params,
              current,
              size: size || 10,
            })
          )
        }}
        summary={() =>
          page?.items?.length ? (
            <Table.Summary fixed>
              <Table.Summary.Row className={styles.total}>
                <Table.Summary.Cell className={styles.footingTitle} index={0}>
                  合计
                </Table.Summary.Cell>
                <Table.Summary.Cell index={1}></Table.Summary.Cell>
                <Table.Summary.Cell index={2}></Table.Summary.Cell>
                <Table.Summary.Cell index={3} align='right'>
                  {params.drugType != 1 ? ' ' : all?.totalCount}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={4} align='right'>
                  {params.drugType != 1 ? ' ' : all?.totalRetail?.toFixed(2)}
                </Table.Summary.Cell>
                {params.drugType == 1 && (
                  <Table.Summary.Cell index={5} align='right'>
                    {params.drugType != 1
                      ? ' '
                      : all?.estimateTotalRealPayAmount?.toFixed(2)}
                  </Table.Summary.Cell>
                )}

                {params.drugType != 1 && (
                  <>
                    <Table.Summary.Cell index={6}></Table.Summary.Cell>
                    <Table.Summary.Cell index={7}></Table.Summary.Cell>
                    <Table.Summary.Cell index={8}></Table.Summary.Cell>
                  </>
                )}
                {params.drugType != 1 && (
                  <>
                    <Table.Summary.Cell index={9} align='right'>
                      {all?.pageTotalCount}
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={10} align='right'>
                      {all?.pageTotalRetail}
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={11} align='right'>
                      {all?.pageEstimateTotalRealPayAmount}
                    </Table.Summary.Cell>
                  </>
                )}
                <Table.Summary.Cell index={12} align='right'>
                  {all?.pageTotalCost}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={13} align='right'>
                  {all?.pageTotalProfitRate}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={14} align='right'>
                  {all?.pageTotalDiff}
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>
          ) : (
            <></>
          )
        }
      />
      <Popover
        content={
          <div
            style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            共{page?.total} 条数据，总数量：{all?.totalCount || '0'}，零售金额：
            {all?.totalRetail || '0.00'}，实收金额：
            {all?.estimateTotalRealPayAmount || '0.00'}，进货金额：
            {all?.totalCost || '0.00'}，利润率：{all?.totalProfitRate || '0.00'}
            ，利润：{all?.totalDiff || '0.00'}
          </div>
        }
        placement='top'
        title='说明'
      >
        <div
          style={{
            position: 'absolute',
            bottom: '20px',
            left: '20px',
            lineHeight: '60px',
            whiteSpace: 'nowrap',
            width: '50%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          共{page?.total} 条数据，总数量：{all?.totalCount || '0'}，零售金额：
          {all?.totalRetail || '0.00'}，实收金额：
          {all?.estimateTotalRealPayAmount || '0.00'}，进货金额：
          {all?.totalCost || '0.00'}，利润率：{all?.totalProfitRate || '0.00'}
          ，利润：{all?.totalDiff || '0.00'}
        </div>{' '}
      </Popover>
    </>
  )
  return (
    <Col
      style={{
        height: 'calc(100% - 30px)',
        padding: '0 15px 20px 15px',
        borderRadius: theme.br,
        backgroundColor: theme.pn,
        marginTop: 10,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <Form
        form={form}
        onFinish={(values) => {
          if (!values?.timeHead && values?._dateRange == 6) {
            return
          }
          dispatch(
            setGetDoctorAuditEntriesParam({
              ...params,
              ...values,
            })
          )
        }}
        initialValues={{
          mergeFlag: 0
        }}
      >
        <Row
          style={{ marginTop: 15, marginBottom: 15 }}
          align='middle'
          justify='space-between'
        >
          <Space>
            <Form.Item name='doctorId' noStyle>
              <Select
                onChange={form.submit}
                style={{ width: 200 }}
                placeholder='请选择医生姓名'
                allowClear
                showSearch
                filterOption={(input, option) => {
                  return option?.className
                    ? ((option?.className as unknown) as string)
                      .toLowerCase()
                      .includes(input.toLowerCase())
                    : false
                }}
              >
                {doctors.map((d) => (
                  <Select.Option
                    className={d.mnemonicCode}
                    key={d.id}
                    value={d.id}
                  >
                    {d.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item name='itemName' noStyle>
              <Input
                placeholder='项目名称'
                style={{ width: '8rem' }}
                onChange={form.submit}
                allowClear
              />
            </Form.Item>
            <Form.Item name='drugType' noStyle>
              <Select
                onChange={() => {
                  setEntries([])
                  form.submit()
                  // setTag
                }}
                style={{ width: '8rem' }}
                placeholder='项目类型'
                allowClear
              >
                <Select.Option value={0}>药品</Select.Option>
                <Select.Option value={1}>诊疗</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item name='billingCategory' noStyle>
              <Select
                onChange={form.submit}
                style={{ width: '8rem' }}
                placeholder='开票项目'
                allowClear
              >
                {BillingCategories.map((c) => (
                  <Select.Option key={c} value={c}>
                    {BillingCategoryName(c)}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item name='mergeFlag' noStyle>
              <Select
                onChange={() => {
                  form.submit()
                }}
                defaultValue={0}
                style={{ width: '8.5rem' }}
                placeholder='是否合并批次'
                allowClear={false}
              >
                <Select.Option value={0}>不合并</Select.Option>
                <Select.Option value={1}>合并</Select.Option>
              </Select>
            </Form.Item>
            <DateSelect
              style={{ width: '8rem' }}
              labelPrefix=''
              allowClear={false}
              namePrefix='time'
              options={TJFXTime}
              placeholder='日期范围-全部'
              initialValue={DateRangeType.Today}
              onChange={form.submit}
            />
            <Button type='primary' onClick={form.submit} loading={pageLoading}>
              查询
            </Button>
          </Space>
          <Space>
            <Button type='primary' onClick={outClued} loading={exportLoading}>
              导出
            </Button>
            <Button type='primary' onClick={() => printRef.current?.print()}>
              打印
            </Button>
          </Space>
        </Row>
      </Form>
      <div
        style={{
          textAlign: 'center',
          color: theme.tc1,
          fontWeight: 'bold',
          fontSize: '1.5rem',
          marginBottom: 10,
        }}
      >
        {name}-医生核算明细
      </div>
      {table()}
      <PrintFrame
        ref={printRef}
        title={
          JSON.parse(localStorage.getItem('credentials') as string)?.tenantName
        }
        subTitle='医生核算明细'
      >
        <Row style={{ marginBottom: '10px', lineHeight: '32px' }}></Row>
        {table(true)}
      </PrintFrame>
    </Col>
  )
}
